import { getCurrentInstance } from 'vue';

// eslint-disable-next-line import/prefer-default-export
export const useStore = () => {
  const vm = getCurrentInstance();
  if (!vm) throw new Error('must be called in setup');
  return vm.proxy.$store;
};
